import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { CheckCircle2, AlertCircle, Landmark, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function GoCardlessComplete() {
    const [sp]       = useSearchParams();
    const navigate   = useNavigate();
    const [status, setStatus] = useState('checking'); // checking | success | cancelled

    useEffect(() => {
        // GoCardless appends ?id=BRF_xxx on success, nothing (or exit param) on cancel
        const outcome = sp.get('outcome') || (sp.get('id') ? 'success' : 'unknown');
        if (outcome === 'success' || sp.get('id')) {
            setStatus('success');
        } else {
            setStatus('cancelled');
        }
    }, [sp]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-[color:var(--bm-bg,#f8fafc)] px-4">
            <div className="bg-white rounded-2xl border border-gray-200 shadow-sm max-w-md w-full p-10 text-center space-y-5">
                {/* Logo */}
                <div className="flex justify-center mb-2">
                    <div className="w-12 h-12 rounded-xl flex items-center justify-center" style={{ background: '#1a56db' }}>
                        <Landmark size={24} className="text-white" />
                    </div>
                </div>

                {status === 'checking' && (
                    <>
                        <Loader2 size={40} className="mx-auto text-blue-500 animate-spin" />
                        <p className="text-gray-500 text-[14px]">Verifying your authorisation…</p>
                    </>
                )}

                {status === 'success' && (
                    <>
                        <CheckCircle2 size={48} className="mx-auto text-emerald-500" />
                        <h1 className="text-[22px] font-bold text-gray-900">Direct Debit authorised</h1>
                        <p className="text-gray-500 text-[14px] leading-relaxed">
                            Your mandate is set up. Your payment will be collected within <strong>2–3 working days</strong> and future invoices can be collected automatically.
                        </p>
                        <div className="bg-blue-50 border border-blue-100 rounded-xl px-5 py-4 text-[13px] text-blue-800 text-left space-y-1">
                            <div className="font-semibold mb-1">What happens next</div>
                            <div>• You'll receive a confirmation email from GoCardless</div>
                            <div>• Payment clears in 2–3 working days</div>
                            <div>• Your mandate stays active for future invoices</div>
                        </div>
                        <Button
                            onClick={() => navigate('/invoices')}
                            className="w-full h-10"
                            style={{ background: '#1a56db' }}
                        >
                            Back to invoices
                        </Button>
                    </>
                )}

                {status === 'cancelled' && (
                    <>
                        <AlertCircle size={48} className="mx-auto text-amber-500" />
                        <h1 className="text-[22px] font-bold text-gray-900">Setup not completed</h1>
                        <p className="text-gray-500 text-[14px] leading-relaxed">
                            You cancelled the Direct Debit setup. No payments have been taken. You can retry from your invoice at any time.
                        </p>
                        <Button
                            onClick={() => navigate('/invoices')}
                            variant="outline"
                            className="w-full h-10"
                        >
                            Back to invoices
                        </Button>
                    </>
                )}

                <p className="text-[11px] text-gray-400">
                    Powered by GoCardless · UK Bacs Direct Debit · FCA regulated
                </p>
            </div>
        </div>
    );
}
